export default "__VITE_ASSET__12d1b4c4__"